/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// document.querySelector('#shopify-section-header').style.top = `${document.querySelector('#shopify-section-announcement-bar').offsetHeight}px`;
// $(window).resize(function() {
//   document.querySelector('#shopify-section-header').style.top = `${document.querySelector('#shopify-section-announcement-bar').offsetHeight}px`;
// });
if(document.querySelector('#shopify-section-announcement-bar')) {
  document.querySelector('#shopify-section-header').prepend(document.querySelector('#shopify-section-announcement-bar'))
}

function openMiniCart(add_cut_sample, add_full_sample) {
  var currentVariantTitle = jQuery('.product-block-list__item [name="id"] option:selected').data('title'), newVariantTitle, variantId, product;
  
  if (add_cut_sample) {
    const cutSampleBtn = document.querySelector('.free-cut-sample');
    var option_values = currentVariantTitle.split(" / ");
    if(cutSampleBtn) {
      var index = cutSampleBtn.dataset.index;
      variantId = cutSampleBtn.dataset.variantId;
      for (var i = 0; i < option_values.length; i++) {
        if (i == parseInt(index)) option_values[i] = "10cm x 10cm";
      }
      newVariantTitle = option_values.join(" / ");
      variantId = jQuery('.product-block-list__item [name="id"] option[data-title="' + newVariantTitle +'"]').val();
      product = JSON.parse(cutSampleBtn.dataset.product);
    }
  }
  if (add_full_sample) {
    const selectedOption = jQuery('.product-block-list__item [name="id"] option:selected');
    variantId = selectedOption.val();
    product = JSON.parse(document.querySelector('.full-tile-sample').dataset.product);
  }
  const event = new CustomEvent('product:added', {
    bubbles: true,
    detail: {
      variant: {
        price: 0,
        id: (typeof variantId != 'undefined' && variantId != null && variantId != '' ? variantId.toString() : '')
      },
      quantity: 1,
      product: product
    }
  });
  document.querySelector('.header__action-item--cart').dispatchEvent(event);  
}

for (var i = 0; i < document.querySelectorAll('.color-swatch').length; i++) {
  document.querySelectorAll('.color-swatch')[i].addEventListener("mouseenter", function(){
    if (this.closest('.product-item') && this.closest('.product-item').querySelector('.product-item__hover-image')) this.closest('.product-item').querySelector('.product-item__hover-image').remove();
    
    var image = (this.querySelector('.color-swatch__radio') ? this.querySelector('.color-swatch__radio').dataset.imageUrl : null);
    if (typeof image != 'undefined' && image != null && image != '') {
      image = image.replace("//", "https://").replace('{width}', '350');
      jQuery(this.closest('.product-item').querySelector('.aspect-ratio')).append('<img src="' + image +'" class="product-item__hover-image" />')
    }

    var index = jQuery(this).closest('.product-item__info').find('.color-swatch').index(this);
    if (index > -1) {
      jQuery(this).closest('.product-item').find('.price-item').addClass('hide');
      jQuery(this).closest('.product-item').find('.price-item').eq(index).removeClass('hide');
    };
  });
  document.querySelectorAll('.color-swatch')[i].addEventListener("mouseleave", function(){
    if (this.closest('.product-item') && this.closest('.product-item').querySelector('.product-item__hover-image')) this.closest('.product-item').querySelector('.product-item__hover-image').remove();
    jQuery(this).closest('.product-item').find('.price-item').addClass('hide');
    jQuery(this).closest('.product-item').find('.price-item').eq(0).removeClass('hide');
  });
}

// Add selected variant to the wishlist on product page
// function swymCallbackFn(swat) {
//  for (var i = 0; i < document.querySelectorAll('.color-swatch').length; i++) {
//    document.querySelectorAll('.color-swatch')[i].addEventListener("click", function(){
//      var variantId = this.dataset.variantId; 
//       console.log(variantId);
//       window.triggerSwymVariantEvent(parseInt(variantId));
//       var index = jQuery(this).closest('.product-item__info').find('.color-swatch').index(this);
//       if (index > -1) {
//        jQuery(this).closest('.product-item').find('.swym-button').toggleClass('hide', index != 0)
//       };
//       if (jQuery(this).closest('.product-item').length > 0) location.href = jQuery(this).attr('href');
//       swat.initializeActionButtons(".aspect-ratio");/* parent container of the where the button is rendered */
//    });
//  }
// }
// if (!window.SwymCallbacks) {
//     window.SwymCallbacks = [];
// }
// window.SwymCallbacks.push(swymCallbackFn);

function cutSample(event) {
  event.preventDefault();
  var index = event.target.dataset.index;
  var optionName = typeof event.target.dataset.option != 'undefined' ? event.target.dataset.option : '10cm x 10cm';
  if (typeof index != 'undefined' && index != null && index != '') {
    var variantId = typeof event.target.dataset.variantId != 'undefined' ? event.target.dataset.variantId : jQuery('.product-block-list__item [name="id"] option[data-sku*="CUT"][data-price="0"], .product-block-list__item [name="id"] option[data-sku*="SAMPLE"][data-price="0"]').val();
    if (typeof variantId != 'undefined' && variantId != null && variantId != '') {
      if(!!event.target) event.target.disabled = true;
      jQuery.getJSON('/cart.json', function(cart) {
        var free_cut_samples = 0;
        for (var i = 0; i < cart.items.length; i++) {
          if ((cart.items[i].variant_options.indexOf('10cm x 10cm') > -1 || cart.items[i].sku.includes('CUT') || cart.items[i].sku.includes('SAMPLE')) && cart.items[i].price == 300) free_cut_samples += cart.items[i].quantity;
        }
        const cutLine = cart.items.find(item => item.id.toString() == variantId);

        if (free_cut_samples >= window.tileLimits.total) {
          event.stopPropagation();
          document.querySelector('#modal-free-sample-unavailable .modal__inner').innerHTML = window.customStrings.modals.cutTotalLimit;
          jQuery('[aria-controls="modal-free-sample-unavailable"]').trigger('click')  
        } else if(cutLine && cutLine.quantity >= window.tileLimits.perCutSample) {
          event.stopPropagation();
          document.querySelector('#modal-free-sample-unavailable .modal__inner').innerHTML = window.customStrings.modals.cutPerLimit;
          jQuery('[aria-controls="modal-free-sample-unavailable"]').trigger('click')
        } else {
          var data = {
            items: [
              {
                quantity: 1,
                id: variantId,
                properties: {
                  'Cut Sample': optionName
                }
              }
            ]
          };

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          })
          .then((response) => response.json())
          .then((cart) => {
            openMiniCart(true, false);
            $.post('/cart/update.js', "attributes[Pickup Date]=");
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if(!!event.target) event.target.disabled = false;
          });
        }
      });
    }
  }
}

if (theme.pageType == "product") {
  // Move Product Wishlist Icon into the product image container
  var productWishlistChecker = setInterval(function(){
    if (document.querySelector('.swym-button-bar')) {
      clearInterval(productWishlistChecker);
      jQuery('.swym-button-bar').prependTo('.product-gallery__carousel-wrapper');
    }
  }, 500);

  // Cut Sample
  const cutSampleBtn = document.querySelector('.free-cut-sample');
  cutSampleBtn?.addEventListener("click", function(e) {
    cutSample(e)
  });

  // Full Sample
  const fullSampleBtn = document.querySelector('.full-tile-sample');
  fullSampleBtn?.addEventListener("click", function(e){
    e.preventDefault();
    fullSampleBtn.disabled = true;
    let productJSON = JSON.parse(fullSampleBtn.dataset?.product);
    const selectedOption = jQuery(`.product-block-list__item [name="id"] option[value="${e.target.dataset.variantId}"]`);
    var variantId = selectedOption.val();
    var optionTitle = selectedOption.attr('data-title');
    var data = {
      items: [
        {
          quantity: 1,
          id: variantId,
          properties: {
            'Full size sample': optionTitle
          }
        }
      ]
    };

    $.getJSON('/cart', (cart) => {
      let tileCount = 0;
      let runAfter = true;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].product_type == 'Tile' || cart.items[i].product_type == 'Box') tileCount += 1;
      }
      if (productJSON && (productJSON.type == 'Tile' || productJSON.type == 'Box')) {
        if (tileCount >= window.tileLimits.total) runAfter = false;
      }
      if (runAfter) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then((response) => response.json())
        .then((cart) => {
          openMiniCart(false, true);
          $.post('/cart/update.js', "attributes[Pickup Date]=");
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          fullSampleBtn.disabled = false;
        });
      } else {
        $('[aria-controls="modal-tile-limit"]').trigger('click');
      }
    });
  });
}

window.initFreeBtnsForPlp = function() {
  const freeBtns = document.querySelectorAll('[data-free-cut-btn]');
  freeBtns.forEach((freeBtn) => {
    freeBtn.addEventListener('click', (e) => {
      const variantId = e.target.dataset.variantId;
      const product = JSON.parse(e.target.dataset.product);
      jQuery.getJSON('/cart.json', function(cart) {
        var free_cut_samples = 0;
        for (var i = 0; i < cart.items.length; i++) {
          if ((cart.items[i].variant_options.indexOf('10cm x 10cm') > -1 || cart.items[i].sku.includes('CUT') || cart.items[i].sku.includes('SAMPLE')) && cart.items[i].price == 300) free_cut_samples += cart.items[i].quantity;
        }
        if (free_cut_samples >= window.tileLimits.total) {
          jQuery('[aria-controls="modal-free-sample-unavailable"]').trigger('click')  
        } else {
          var data = {
            items: [
              {
                quantity: 1,
                id: variantId,
                properties: {
                  'Cut Sample': '10cm x 10cm'
                }
              }
            ]
          };

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          })
          .then(response => {
            const event = new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: {
                  price: 0,
                  id: variantId
                },
                quantity: 1,
                product: product
              }
            });
            document.querySelector('.header__action-item--cart').dispatchEvent(event);
            $.post('/cart/update.js', "attributes[Pickup Date]=");
            return response.json();
          });
        }
      });
    });
  });
};
window.initFreeBtnsForPlp();

window.initFullBtnsForPlp = function() {
  const freeBtns = document.querySelectorAll('[data-full-btn]');
  freeBtns.forEach((freeBtn) => {
    freeBtn.addEventListener('click', (e) => {
      const variantId = e.target.dataset.variantId;
      const product = JSON.parse(e.target.dataset.product);
      const optionTitle = e.target.dataset.option;
      var data = {
        items: [
          {
            quantity: 1,
            id: variantId,
            properties: {
              'Full size sample': optionTitle
            }
          }
        ]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(response => {
        openMiniCart(false, true);
        $.post('/cart/update.js', "attributes[Pickup Date]=");
        return response.json();
      });
    });
  });
};
window.initFullBtnsForPlp();

window.initStockBadges = function() {
  let productIds = [];
  document.querySelectorAll('.product-item[data-product-id]').forEach((item) => {
    productIds.push(`"gid://shopify/Product/${item.dataset.productId}"`);
  });
  
  const storefrontToken = location.host == 'tilestyle.ie' ? 'cce42f3c3febe1dc0760c8557ddb822f' : 'e78153da5103d318dfeadb0894f5d3e5';
  const apiUrl = `https://${location.host == 'tilestyle.ie' ? 'tilestyle-b2c-shop' : 'tilestyle-b2c-uat'}.myshopify.com/api/2023-01/graphql`;
  const apiHeaders = new Headers({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontToken
  });
  const query = () => `{
    nodes(ids: [${productIds.join(',')}]) {
      ...on Product {
        id
        availableForSale
        totalInventory
        vendor
      }
    }
  }`;
  
  fetch(apiUrl, {
    method: 'POST',
    headers: apiHeaders,
    body: JSON.stringify({query: query(), variables: {}})
  }).then((response) => response.json())
  .then((data) => {
    console.log(data);
    if (data.data && data.data.nodes.length > 0) {
      data.data.nodes.forEach((node) => {
        if(node) {
          const id = node.id.replace("gid://shopify/Product/", "");
          const productItems = document.querySelectorAll(`.product-item[data-product-id="${id}"]`);
          productItems.forEach((productItem) => {
            if (productItem.querySelector('.product-item__stock')) productItem.querySelector('.product-item__stock').remove();
            if (node.availableForSale) {
              let html = '';
              if(node.vendor == "Ca'Pietra")
                html = '<span class="product-item__stock product-item__stock--available">Available to Order</span>';
              else
                if (node.totalInventory > 0)
                  html = '<span class="product-item__stock product-item__stock--in">In Stock</span>';
                else
                  html = '<span class="product-item__stock product-item__stock--available">Available to Order</span>';
              productItem.querySelector('.product-item__image-wrapper').innerHTML += html;
            }
          });
        }
      })
    }
  }).catch((e) => {
    console.error(e);
  })
};

for (var i = 0; i < document.querySelectorAll('.swym-button').length; i++) {
  document.querySelectorAll('.swym-button')[i].addEventListener("click", function() {
    if (this.className.indexOf('swym-added') < 0) {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'add_to_wishlist',
        'eventCategory': 'wishlist',
        'eventAction': 'product_added',
        'eventLabel': this.dataset.productTitle
      });
    }
  });
}

window.initProductClickDL = function() {
  for (var i = 0; i < document.querySelectorAll('a[track-click-product]').length; i++) {
    $(document.querySelectorAll('a[track-click-product]')[i]).off('click');
    $(document.querySelectorAll('a[track-click-product]')[i]).on('click', function(e) {
      var product = JSON.parse($(this).closest('.product-item').data('product'));
      if (product) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          'event': 'productClick',
          'ecommerce': {
            'currencyCode': Shopify.currency.active,  
            'click': {
              'actionField': {'list': $('body').data('template')},
              'products': [product] 
            }
          }
        });
      } 
    });
  }
};

window.initProductClickDL();

$('[action^="/cart"]').on('submit', function(e) {
  if ($(this).find('#checkout_continue').length > 0 && !$(this).find('#checkout_continue').prop('checked')) {
    e.preventDefault();
    e.stopPropagation();
    alert('Please accept our Terms & Conditions before proceeding to Checkout.');
  }
})

// Change UK to Northern Ireland
if (document.querySelector('[name="country"]') && document.querySelector('[name="country"]').querySelector('[value="United Kingdom"]')) {
  document.querySelector('[name="country"]').querySelector('[value="United Kingdom"]').innerHTML = 'Northern Ireland'
}

// Show form submit success
if (location.href.indexOf('submit=true') > -1) {
  $('.form-submit-success').removeClass('hide');
  $('.contact-form-title, .embed-sh-form form, .contact-form-selector').addClass('hide');
  // jQuery('[aria-controls="modal-submit-success"]').trigger('click')
}

// Tigger PLP listing
var tags = location.href.split('?')[0].split('/')[5];
if (location.search.indexOf('sort_by=price-descending') > -1 || location.search.indexOf('sort_by=price-ascending') > -1 || (tags != '' && tags != null && (typeof tags != 'undefined'))) {
  var page = '';
  if (location.href.split('?').length > 1) {
    var params = location.href.split('?')[1].split('&');
    for (var i = 0; i < params.length; i++) {
      if (params[i].indexOf('page=') > -1) {
        page = params[i].split('=')[1];
        break;
      }
    }  
  }
  
  window.currentPaginationNumber = page;
  $('#display-by-selector .value-picker__choice-item.is-selected').trigger('click');
  // $('#sort-by-selector .value-picker__choice-item.is-selected').trigger('click');
}

// Area Calculator
var areaOpener = document.querySelector('.area-calculator__head--inner');
if (areaOpener) {
  areaOpener.addEventListener("click", function(){
    this.closest('.area-calculator').classList.toggle('opened')
  });

  const areaUnitAdd = document.getElementById('add-area');
  const areaUnitTemplate = document.getElementById('area-field-template').innerHTML;
  const areaMain = document.querySelector('.area-calculator__main--inner');

  function refreshValue() {
    let sqm = 0;
    const containers = document.querySelectorAll('.area-item');
    for (var j = 0; j < containers.length; j++) {
      let container = containers[j];
      const inputs = container.querySelectorAll('input');
      let unit_sqm = 1;
      for (var i = 0; i < inputs.length; i++) {
        const unit = inputs[i].closest('.area-item__column').querySelector('select').value;
        if (unit == 'ft')
          unit_sqm = unit_sqm * (parseFloat(inputs[i].value) || 0) * 0.3048;
        else
          unit_sqm = unit_sqm * (parseFloat(inputs[i].value) || 0);
      }
      sqm += unit_sqm;
      container.querySelector('.area-unit__result-detail').innerHTML = unit_sqm.toFixed(2);
    }
    document.querySelector('.calculation-result__details').innerHTML = sqm.toFixed(2);
    if (sqm > 0 && document.querySelector('#m2-qty')) {
      document.querySelector('#m2-qty').value = sqm.toFixed(2);
      const event = new Event('keyup');
      document.querySelector('#m2-qty').dispatchEvent(event);
      const changeEvent = new Event('change');
      document.querySelector('#m2-qty').dispatchEvent(changeEvent);
    }
  }

  function resetPositionTexts() {
    const areaItems = document.querySelectorAll('.area-calculator__main--inner .area-item');
    if (areaItems) {
      for (var i = 0; i < areaItems.length; i++) {
        let pos = i + 1;
        areaItems[i].querySelector('.area-label').innerHTML = 'Area ' + pos;
      }
    }
  }

  function initArea(container) {
    const trash = container.querySelector('.area-unit__remove');
    if (trash) {
      trash.addEventListener("click", function(){
        this.closest('.area-item').remove();
        refreshValue();
        resetPositionTexts();
      });
    }

    const inputs = container.querySelectorAll('input');
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener("keyup", function() {
        if (!isNaN(this.value) && parseFloat(this.value) < 0) {
          this.value = 0;
        }
        refreshValue()
      });
    }

    const selects = container.querySelectorAll('select');
    for (var i = 0; i < selects.length; i++) {
      selects[i].addEventListener("change", function() {
        const unit = this.value;
        let input = this.closest('.area-item__column').querySelector('input');
        let sibling = $(this).closest('.area-item').find('select').not(this)[0];
        if (unit == 'ft') {
          if (!isNaN(input.value)) input.value = (parseFloat(input.value) / 0.3048).toFixed(2);
          if (sibling.value == 'm') {
            let siblingInput = sibling.closest('.area-item__column').querySelector('input');
            sibling.value = 'ft';
            if (!isNaN(siblingInput.value)) siblingInput.value = (parseFloat(siblingInput.value) / 0.3048).toFixed(2);
          }
        } else {
          if (!isNaN(input.value)) input.value = (parseFloat(input.value) * 0.3048).toFixed(2);
          if (sibling.value == 'ft') {
            let siblingInput = sibling.closest('.area-item__column').querySelector('input');
            sibling.value = 'm';
            if (!isNaN(siblingInput.value)) siblingInput.value = (parseFloat(siblingInput.value) * 0.3048).toFixed(2);
          }
        }
        refreshValue();
      });
    }
  }

  areaUnitAdd.addEventListener("click", function(){
    $(areaMain).append(areaUnitTemplate);
    resetPositionTexts();
    initArea(areaMain.querySelector('.area-item:last-child'));
  });
  var event = new Event('click');
  areaUnitAdd.dispatchEvent(event);
}

const howToMeasureTooltip = document.querySelector('.area-calculator__info');
if (howToMeasureTooltip) {
  howToMeasureTooltip.addEventListener("click", function(){
    jQuery('[aria-controls="modal-how-to-measure"]').trigger('click')
  });
}

// CountDown Timer
var countDownTimer = document.querySelector('.countdown-timer--wrapper');
if (countDownTimer && countDownTimer.dataset.endDate) {
  var endDate = new Date(countDownTimer.dataset.endDate);
  var now = new Date();
  if (endDate.getTime() - now.getTime() > 10000) {
    const daysSlot = document.querySelector('.countdown-timer__days');
    const hoursSlot = document.querySelector('.countdown-timer__hours');
    const minutesSlot = document.querySelector('.countdown-timer__minutes');
    const secondsSlot = document.querySelector('.countdown-timer__seconds');
    countDownTimer.classList.remove('hide');
    var countDownTimerInterval = setInterval(function(){
      var now = new Date();
      var diff = (endDate.getTime() - now.getTime()) / 1000;
      if (diff > 0) {
        let days = Math.floor(diff / 3600 / 24);
        let hours = Math.floor((diff - days * 3600 * 24) / 3600);
        let minutes = Math.floor((diff - days * 3600 * 24 - hours * 3600) / 60);
        let seconds = Math.round(diff - days * 3600 * 24 - hours * 3600 - minutes * 60);
        days = (days >= 10 ? days.toString() : "0" + days.toString());
        hours = (hours >= 10 ? hours.toString() : "0" + hours.toString());
        minutes = (minutes >= 10 ? minutes.toString() : "0" + minutes.toString());
        seconds = (seconds >= 10 ? seconds.toString() : "0" + seconds.toString());
        
        daysSlot.querySelector("span:nth-child(1)").innerHTML = days.substring(0, days.length - 1)
        daysSlot.querySelector("span:nth-child(2)").innerHTML = days.substring(days.length - 1)
        hoursSlot.querySelector("span:nth-child(1)").innerHTML = hours.substring(0, hours.length - 1)
        hoursSlot.querySelector("span:nth-child(2)").innerHTML = hours.substring(hours.length - 1)
        minutesSlot.querySelector("span:nth-child(1)").innerHTML = minutes.substring(0, minutes.length - 1)
        minutesSlot.querySelector("span:nth-child(2)").innerHTML = minutes.substring(minutes.length - 1)
        secondsSlot.querySelector("span:nth-child(1)").innerHTML = seconds.substring(0, seconds.length - 1)
        secondsSlot.querySelector("span:nth-child(2)").innerHTML = seconds.substring(seconds.length - 1)
      } else {
        clearInterval(countDownTimerInterval);
        countDownTimer.classList.add('hide');
      }
    }, 1000);
  }
}

// Render Shopable Hotspots
function makestring(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
   }
   return result;
}
window.makestring = makestring;

window.renderHotspot = function(parentElement, data) {
  let randomStr = window.makestring(5);
  let pointHtml = '<span class="shopable-hotspot" id="' + randomStr + 'hotspot-' + data['handle'] + '" data-product-handle="' + data['handle'] + '" style="top: ' + data['y_percent'] + '%;left: ' + data['x_percent'] + '%;"><div class="shopable-hotspot-wrapper"><div class="shopable-hotspot-inner"></div></div></span>';

  $(parentElement).append(pointHtml);
  $('#' + randomStr + 'hotspot-' + data['handle']).mouseenter(function() {
    const _this = this;
    let product = window.hotspotProducts ? window.hotspotProducts[this.dataset.productHandle] : null;
    $(this).addClass('active');
    if (this.querySelector('.shopable-hotspot-inner').innerHTML == '' || this.querySelector('.shopable-hotspot-inner').innerHTML == null) {
      $.getJSON('https://tilestyle.ie/collections/tiles/products/' + this.dataset.productHandle + '.json', function(product_data) {
        let html = '';
        if (product_data.product.image) {
          let imageUrl = product_data.product.image.src.replace('.jpg', '_100x.jpg').replace('.png', '_100x.png');
          html += '<img src="' + imageUrl + '" alt="' + product_data.product.image.alt + '" />';
        }
        let price_html = '<p class="shopable-hotspot-product__price regular">€' + product_data.product.variants[0].price + '</p>';
        if (product && product.min_m2_price) {
          price_html = '<p class="shopable-hotspot-product__price ' + (product.min_comp_price ? 'sale' : 'regular') + '">' + (product.multiple ? '<span class="from">From</span> <span class="m2-price-value ' + (product.min_comp_price && product.min_comp_price > product.min_m2_price ? 'price--highlight' : '') + '">' : '<span class="m2-price-value ' + (product.min_comp_price && product.min_comp_price > product.min_m2_price ? 'price--highlight' : '') + '">') + theme.moneyFormat.replace("\{\{amount\}\}", product.min_m2_price.toFixed(2)) + '</span><span class="m2-unit ' + (product.min_comp_price && product.min_comp_price > product.min_m2_price ? 'price--highlight' : '') + '">/m<sup>2</sup></span>' + (product.min_comp_price && product.min_comp_price > product.min_m2_price ? '<span class="m2-comp-price"><span>' + theme.moneyFormat.replace("\{\{amount\}\}", product.min_comp_price.toFixed(2)) +'</span>/m<sup>2</sup></span>' : '') + '</p>';
        } else {
          if (product_data.product.variants[0].compare_at_price && parseFloat(product_data.product.variants[0].compare_at_price) > parseFloat(product_data.product.variants[0].price)) {
            price_html = '<p class="shopable-hotspot-product__price sale">€' + product_data.product.variants[0].price + '<span>€' + product_data.product.variants[0].compare_at_price + '</span></p>';
          }  
        }
        
        html += '<div class="shopable-hotspot-product"><p class="shopable-hotspot-product__title">' + product_data.product.title + '</p>' + price_html + '<a href="https://tilestyle.ie/collections/tiles/products/' + product_data.product.handle + '" target="_blank">View product</a></div>';
        $(_this).find('.shopable-hotspot-inner').html(html);

        let element = $(_this).find('.shopable-hotspot-wrapper');
        const leftPos = _this.offsetLeft;
        const rightPos = screen.width - _this.offsetLeft - 32;
        const innerElement = _this.querySelector('.shopable-hotspot-wrapper');
        if (leftPos < 130) {
          innerElement.style.left = (140 - leftPos).toString() + 'px';
        } else if (rightPos < 130) {
          innerElement.style.left = 'calc( 50% - ' + (140 - rightPos).toString() + 'px )';
        } else {
          innerElement.style.left = '';
        }
      });
    }
  }).mouseleave(function() {
    $(this).removeClass('active');
  });
}

const shopableHotspotsJsons = document.querySelectorAll('[data-json-type="shopable-hotspots"]');
for (var i = 0; i < shopableHotspotsJsons.length; i++) {
  const element = shopableHotspotsJsons[i];
  const data = JSON.parse(shopableHotspotsJsons[i].innerHTML);
  const parentClass = (typeof element.dataset.parentClass == 'undefined' ? '.shopable-hotspots' : ('.' + element.dataset.parentClass));
  const parentElement = element.closest(parentClass);
  if (parentElement && data) {
    for (var j = 0; j < data.length; j++) {
      window.renderHotspot(parentElement, data[j]);
    }
    window.getHotspotProducts();
  }
}
setTimeout(function() {
  window.getHotspotProducts();
}, 3500);
if (shopableHotspotsJsons) {
  $(window).resize(function() {
    const points =  document.querySelectorAll('.shopable-hotspot');
    for (var i = 0; i < points.length; i++) {
      let element = $(points[i]).find('.shopable-hotspot-wrapper');
      const leftPos = points[i].offsetLeft;
      const rightPos = screen.width - points[i].offsetLeft - 32;
      const innerElement = points[i].querySelector('.shopable-hotspot-wrapper');
      if (leftPos < 130) {
        innerElement.style.left = (140 - leftPos).toString() + 'px';
      } else if (rightPos < 130) {
        innerElement.style.left = 'calc( 50% - ' + (140 - rightPos).toString() + 'px )';
      } else {
        innerElement.style.left = '';
      }
    }
  });
}

const articleSlider = document.querySelector('[data-article-slider]');
const articleSliderTemplate = document.querySelector('[data-article-slider-template]');
if (articleSlider && articleSliderTemplate && articleSliderTemplate.querySelectorAll('.carousel-cell').length > 0) {
  articleSlider.innerHTML = articleSliderTemplate.innerHTML;
  var flkty = new Flickity(articleSlider, {
    
  });
}

const articleProductsSlider = document.querySelector('[data-article-products-slider]');
const articleProductsSliderTemplate = document.querySelector('[data-article-products-template]');
if (articleProductsSlider && articleProductsSliderTemplate) {
  const productList = articleProductsSliderTemplate.querySelector('.product-list');
  var flkty = new Flickity(productList, {
    watchCSS: true,
    pageDots: false,
    prevNextButtons: true,
    contain: true,
    groupCells: true,
    cellAlign: 'left',
    draggable: !window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches
  });
  $(articleProductsSlider).append(articleProductsSliderTemplate);
}

const productAccordionTitles = document.querySelectorAll('.product-accordion__item--title');
productAccordionTitles.forEach((title) => {
  title.addEventListener('click', function() {
    if (this.classList.contains('active'))
      this.classList.remove('active');
    else
      this.classList.add('active');
  });
});

if(document.body.dataset.template && document.body.dataset.template == 'product' && document.querySelector('.product-gallery [data-flair-product-badge]')) {
  const customBadge = document.querySelector('[data-custom-flair-badge]');
  setTimeout(() => {
    const badgeWrapper = document.querySelector('.product-gallery [data-flair-product-badge]');
    if(customBadge && badgeWrapper.innerHTML == '') badgeWrapper.innerHTML = customBadge.innerHTML
  }, 1000);
}
